var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-danger-6442930",
    d: "M31.03,73.637,24.994,63.5a.985.985,0,0,0-1.673,0L17.285,73.637a.93.93,0,0,0,.829,1.394H30.187a.936.936,0,0,0,.844-1.394Zm-6.24-.761a.782.782,0,0,1-.553.225.872.872,0,0,1-.567-.225.682.682,0,0,1-.233-.535.783.783,0,0,1,.8-.761.836.836,0,0,1,.553.225.758.758,0,0,1,.233.535A.7.7,0,0,1,24.79,72.876Zm.175-5.732c-.029.2-.087.465-.131.8s-.1.718-.16,1.2c-.044.408-.1.9-.131,1.479a.311.311,0,0,1-.305.282.325.325,0,0,1-.32-.282c-.029-.563-.073-1.07-.116-1.465-.044-.465-.1-.873-.145-1.2s-.1-.577-.131-.789a4.1,4.1,0,0,1-.044-.549.763.763,0,0,1,.2-.634.872.872,0,0,1,.567-.169.83.83,0,0,1,.553.169.764.764,0,0,1,.2.606,2.583,2.583,0,0,1-.044.549Z",
    transform: "translate(-17.157 -63.031)",
    fill: "#ffec00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.63210694925b9496acb3129e9d9f1391.svg";
export { ForwardRef as ReactComponent };